/**
 * Feature gate for the SuperDoc DOCX viewer.
 *
 * Off by default — only enabled when `VITE_SUPERDOC_ENABLED` is explicitly
 * set to `"true"`. This keeps the SuperDoc path gated behind an env-var
 * toggle so launch builds ship only the battle-tested `docx-preview`
 * renderer; development and preview deployments can opt in by setting the
 * env var.
 */
export function isSuperDocEnabled(): boolean {
  return import.meta.env.VITE_SUPERDOC_ENABLED === "true";
}
